import { NavLink, useModel, BrandingStyle,useRoute,DisabledPrompt,Subnav,CCTM,CCTM_nav,CCTM_subnav,CCTM_route,CCTM_link,CCTM_item,CCTM_items,CCTM_demo ,useCCTM} from "bcms-react";
import React, { useRef } from "react";
import { SVGAsset } from "res";
import Nav from 'components/shared/containers/Nav';
import "./styles.css";

export default function BottomNavView(props) {
  const className = props.className ?? "";
  const setSrc = props.setSrc;
  const onRoute = function(component){
    component.setSrc = setSrc;
    return component;
  }
  const xml =  useCCTM(),
            menu = <CCTM nav-id={"bottomNav"} xml={xml} self={Parent}>
                        <CCTM_nav component={BottomNav}/>                            
                        <CCTM_route component={BottomNavItemView} postRender={onRoute}/>                  
                        <CCTM_link component={BottomNavItemView} postRender={onRoute}/> 
                        <CCTM_item component={BottomNavItemView} postRender={onRoute}/>   
                        <CCTM_items component={BottomNavItemView} postRender={onRoute}/>                     
                        <CCTM_demo component={BottomNavItemView} postRender={onRoute}/> 
                         <CCTM_subnav component={BottomNavItemView} postRender={onRoute}/>              
                    </CCTM>;
return menu;
(
<Nav 
  nav-id={"#bottomNav"} 
  nav={BottomNav}
  subnav={<navItem self={navItem}/>} 
   item={BottomNavItemView} 
  items={BottomNavItemView} 
  link={BottomNavItemView} 
  route={BottomNavItemView} 
  demo={BottomNavItemView}      
  setSrc={props.setSrc}
  > 
</Nav> )
/** 
  return (<>
    {options.bid_mabi23 === "60" && <BottomNavWrenView {...props} />}
    {options.bid_mabi23 === "1702" && <BottomNavBACView {...props} />}
    {options.bid_mabi23 === "1224" && <BottomNavManasquanView {...props} />}
    {options.bid_mabi23 === "932" && <BottomNavLakeRidgeView {...props} />}
    {options.bid_mabi23 === "126" && <BottomNavParkNationalView {...props} />}
    {options.bid_mabi23 === "2162" && <BottomHomeTrustSavingsView {...props} />}
    {options.bid_mabi23 === "2132P" && <BottomNeighborsFCUPersonalView {...props} />}
    {options.bid_mabi23 === "2132B" && <BottomNeighborsFCUBusinessView {...props} />}
    {(options.bid_mabi23 !== "1702" && options.bid_mabi23 !== "60" && options.bid_mabi23 !== "1224" && options.bid_mabi23 !== "932" && options.bid_mabi23 !== "126" && options.bid_mabi23 !== "2162" && options.bid_mabi23 !== "2132P" && options.bid_mabi23 !== "2132B") && <BrandingStyle style={{ "backgroundColor": "bottom_nav_bg_mabi23" }} className={className + "bottom-nav-view"}>
      <div className="bottom-nav-container flex-container flex-horizontal align-center">
        <BottomNavItemView setSrc={setSrc} route="accountSummary" text="Accounts" icon="WalletIcon" dataPoint="Accounts_Bottom_Nav" />
        {options.zelle_mabi23 === "true" &&
          <BottomNavItemView setSrc={setSrc} route="zelleIntegrated"
            text={<><div className="zelle-text flex-container flex-horizontal"><p>Zelle</p><span className="r-mark">&reg;</span></div></>}
            icon="ZelleLogoIcon" dataPoint="Zelle_Bottom_Nav" />
        }
        <BottomNavItemView setSrc={setSrc} route="transfers" text="Transfers" icon="OppositeArrowsIcon" dataPoint="Transfers_Bottom_Nav" />
        {options.payments_mabi23 === "true" &&
          <BottomNavItemView setSrc={setSrc} route="rxpmw" text="Payments" icon="DollarSignOutlineIcon" dataPoint="Payments_Bottom_Nav" />
        }
        {options.cards_bottom_nav_mabi23 === "true" && <BottomNavItemView setSrc={setSrc} abi22IframeProps={{ showOnClick: true, pageID: "ch21Standalone" }} route="ch21"
          text={<><div className="zelle-text flex-container flex-horizontal"><p>My Cards</p></div></>}
          icon="CardIcon" dataPoint="Cards_Bottom_Nav" />
        }
        {options.depositcheck_mabi23 === "true" &&
          <BottomNavItemView setSrc={setSrc} route="depositACheckWorkflow" text="Deposits" icon="CameraIcon" dataPoint="Deposits_Bottom_Nav" />
        }
        {options.profile_bottom_nav_mabi23 === "true" &&
          <BottomNavItemView setSrc={setSrc} route="profile" text="Profile" icon="CircleProfileIcon" dataPoint="Profile_Bottom_Nav" />
        }

      </div>
    </BrandingStyle>
    }
  </>



  );*/
}
export function Parent(props){
  const className = props.className ?? "";
  return   <BrandingStyle style={{ "backgroundColor": "bottom_nav_bg_mabi23" }} className={className + "bottom-nav-view"}>
       
      {props.children}
    
      </BrandingStyle>
}
export function BottomNav(props){
 const  {className} = props;
return  ( <div className="bottom-nav-container flex-container flex-horizontal align-top">
            {props.children}
          </div>);
    
   
}
export function navItem(props){


 return  (  <BottomNavItemView  {...props} />
 );
     
    
 }
export function BottomNavItemView(props) {
  const text = props.label ?? "[text]";
  const icon = props.asset_name ?props.asset_name: "";
  const route = props.to ?? "";
  const dataPointIcon = props.datapoint ? { "data-point": props.datapoint + "_Icon" } : {};
  const dataPointLabel = props.datapoint ? { "data-point": props.datapoint + "_Label" } : {};
  const className = props["custom-class"] ?? "";
  const abi22IframeProps = props.abi22IframeProps ?? { showOnClick: false, pageID: "" };
  const ref = useRef();
  const navigate = useRoute();

  const onClick = () => {

    if (props.target=="window" && props.to=="ch21") {
      window.postMessage({ message: "openABI22StandaloneIframe", pageID: "ch21Standalone" }, "*");
    } else {
      navigate(`/content/${ route }`);
      /**removed for now to fix custom menu issue */
      
     props.component.setSrc(route);
    }
  }

  return (
  
    <div className="bottom-nav-item-view flex-width" ref={ref} onClick={onClick}>

      <div className={className + " bottom-nav-item-container flex-container flex-vertical align-center clickable"}>
        <BrandingStyle style={{ "fill": "bottom_nav_icons_mabi23" ,"color": "bottom_nav_icons_mabi23"}} className={" "+(props["asset_custom-class"]?props["asset_custom-class"]: "material-symbols-outlined md-14")}  element={<SVGAsset id={icon} {...dataPointIcon}/>} />
        <BrandingStyle style={{ "color": "bottom_nav_icons_mabi23" }} className="nav-item-label" element={<span {...dataPointLabel}>{text}</span>} />
      </div>


    </div>

  );
}
